import React, { forwardRef, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import Grid from '@material-ui/core/Grid'

import clientCompanySchema from '@galo-monitor/forms/schemas/company/clientCompany.schema'
import { useT } from '@galo-monitor/i18n'
import { useSnackbar } from '@galo-monitor/snackbar'
import { CompanyActions } from '@galo-monitor/stores/company'
import Form from '@galo-monitor/web-components/Form'
import InputEmail from '@galo-monitor/web-components/InputEmail'
import InputPhone from '@galo-monitor/web-components/InputPhone'
import InputText from '@galo-monitor/web-components/InputText'

import { Container } from './styles'

const ClientCompanyForm = forwardRef((props, formRef) => {
  const { clientCompany, loading, setLoading, onSuccess, onError } = props
  const dispatch = useCallback(useDispatch(), [])
  const t = useT()
  const snackbar = useSnackbar()

  const handleSubmit = useCallback(
    (data) => {
      setLoading(true)
      dispatch(CompanyActions.saveClientCompany(
        {
          ...clientCompany,
          ...data
        },
        () => {
          snackbar.success(t('{this} {action} successfully!', {
            this: t('{this} account', {
              howMany: 1,
              this: t('company client', { howMany: 1 })
            }),
            action: toLower(t(isEmpty(clientCompany) ? 'created' : 'updated', { gender: 'female', howMany: 1 }))
          }))
          onSuccess(data)
        },
        onError
      ))
    },
    [dispatch, clientCompany, onError, onSuccess, setLoading, snackbar, t]
  )

  return (
    <Form
      ref={ formRef }
      schemaConstructor={ clientCompanySchema }
      onSubmit={ handleSubmit }
    >
      <Container>
        <Grid container spacing={ 2 }>
          <Grid item xs={ 12 } sm={ 6 }>
            <InputText
              name="name"
              label={ t('name') }
              defaultValue={ clientCompany.name }
              disabled={ loading }
              fullWidth
            />
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <InputText
              name="name_responsible"
              label={ t('responsible') }
              defaultValue={ clientCompany.nameResponsible }
              disabled={ loading }
              fullWidth
            />
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <InputPhone
              name="phone"
              label={ t('main phone') }
              defaultValue={ clientCompany.phone }
              disabled={ loading }
              fullWidth
            />
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <InputEmail
              name="email"
              label={ t('email') }
              defaultValue={ clientCompany.email }
              disabled={ loading }
              fullWidth
            />
          </Grid>
        </Grid>
      </Container>
    </Form>
  )
})

ClientCompanyForm.propTypes = {
  clientCompany: PropTypes.object,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
}

ClientCompanyForm.defaultProps = {
  clientCompany: {},
  loading: false,
  setLoading: () => {},
  onSuccess: () => {},
  onError: () => {}
}

export default ClientCompanyForm
